import { app } from '../../../../bootstrap/core';
import { directDebitFormComponent } from './directDebitForm.component';
import { DirectDebitFormFields } from './directDebitForm.constants';

app.component('directDebitForm', directDebitFormComponent);
app.value('directDebitFormFields', DirectDebitFormFields);
